module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_13.27fba31e.png";